import React, { useEffect, useState } from "react";
import "./index.scoped.css";
import {
  getCasinoBetsAPI,
  getCasinoExposureAPI,
  getCasinoLastTenResultAPI,
  getCasinoOddsAPI,
} from "../../service/casino";
import { useQuery } from "react-query";
import CasinoVideo from "./components/CasinoVideo";
import Timer from "./components/Timer";
import {
  CARD_ARRAY,
  cardArray,
  CASINO_VIDEO,
  getCasinoPlExposureByRunner,
  getOddForEntity,
  setBet,
} from "./CasinoGeneric";
import PlaceBet from "./components/PlaceBet";
import { useDispatch } from "react-redux";
import PlacedBet from "./components/PlacedBet";
import CasinoPage from "./components/CasinoPage";
import { useLocation } from "react-router-dom";
export default function Lucky15() {
  const location = useLocation();
  var GAME_ID = location.pathname.split("/");
  GAME_ID = GAME_ID[GAME_ID.length - 1];
  // const GAME_ID = "AAA";
  // const VIDEO_ID = CASINO_VIDEO.amarAkbarAnthony;
  const VIDEO_ID = "lucky15";

  const dispatch = useDispatch();
  const [casinoPlData, setCasinoPlData] = useState([]);

  const casinoData = useQuery(
    "getCasinoOdds",
    () => getCasinoOddsAPI(GAME_ID),
    {
      refetchInterval: 800,
    }
  );

  const getPlExposure = async () => {
    const { response } = await getCasinoExposureAPI(
      casinoData?.data?.response?.marketId
    );
    setCasinoPlData(response);
  };
  useEffect(() => {
    if (casinoData?.data?.response?.marketId) {
      let interval = setInterval(() => {
        getPlExposure();
      }, 2000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [casinoData?.data?.response?.marketId]);

  return (
    <CasinoPage
      casino={casinoData?.data}
      VIDEO_ID={VIDEO_ID}
      // VIDEO_ID={GAME_ID}
      GAME_ID={GAME_ID}
      // VIDEO_ID={CASINO_VIDEO.thirtyTwoCardB}
      //  VIDEO_ID={GAME_ID}
      // GAME_ID={GAME_ID}
        gameName={"Lucky 15"}
    >
      {/* <div className="center-main-container casino-page"> */}
      {/* <div className="center-container"> */}
      {/* <div className="casino-page-container ball-by-ball"> */}
      {/* <div className="casino-header"> */}
      {/* <span className="casino-name">
        Lucky 15
        <a className="ms-1">
          <small>Rules</small>
        </a>
      </span>
      <span className="casino-rid d-none d-xl-inline-block">
        <small>
          Round ID: <span>161250425195635</span>
        </small>
      </span> */}
      {/* </div> */}
      {/* <div className="casino-title-header-mobile d-xl-none"> */}
      {/* <ul className="nav nav-tabs menu-tabs">
              <li className="nav-item">
                <div className="nav-link active">Game</div>
              </li>
              <li className="nav-item">
                <div className="nav-link">Placed Bet (0)</div>
              </li>
            </ul> */}
      {/* <div className="pe-2">
              <span className="casino-rid">
                Round ID: <span>161250425195635</span>
              </span>
            </div> */}
      {/* </div> */}
      {/* <div className=""> */}
      {/* <div className="casino-video"> */}
      {/* <div className="video-box-container"> */}
      {/* <div className="casino-video-box"> */}
      {/* <iframe src="/mediaplayer/lucky15/6d8e16ac-83fe-43da-beac-050fa5560ed3?ip=122.160.119.41" /> */}
      {/* </div> */}
      {/* </div> */}
      {/* <div className="clock lucky15 flip-clock-wrapper">
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">2</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">2</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">1</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">1</div>
                    </div>
                  </a>
                </li>
              </ul>
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">4</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">4</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">3</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">3</div>
                    </div>
                  </a>
                </li>
              </ul>
            </div> */}
      {/* </div> */}
      <div className="casino-detail detail-page-container position-relative">
        <div className="game-market market-6 container-fluid container-fluid-5">
          <div className="market-title row row5">Runs</div>
          <div className="market-header row row5">
            <div className="col-12 col-md-4 d-none d-md-block">
              <div className="market-row">
                <div className="market-nation-detail" />
                <div className="market-odd-box back">
                  <b>Back</b>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 d-none d-md-block">
              <div className="market-row">
                <div className="market-nation-detail" />
                <div className="market-odd-box back">
                  <b>Back</b>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="market-row">
                <div className="market-nation-detail" />
                <div className="market-odd-box back">
                  <b>Back</b>
                </div>
              </div>
            </div>
            <div className="fancy-min-max-box" />
          </div>
          <div className="market-body row row5">
            <div className="col-12 col-md-4">
              <div className="fancy-market" data-title="OPEN">
                <div className="market-row">
                  <div className="market-nation-detail">
                    <span className="market-nation-name pointer">
                      0 Runs
                      <p className="casino-nation-book d-none d-md-block w-100">
                        {getCasinoPlExposureByRunner(casinoPlData, "0 Runs")}
                      </p>
                    </span>
                  </div>
                  <div className=" blb-box ">
                    <div className="market-odd-box back ">
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() => setBet("0 Runs", casinoData, dispatch)}
                      >
                        <span className="market-odd">
                          {getOddForEntity("0 Runs", casinoData, true)}
                        </span>
                        <span className="market-volume">
                          {getOddForEntity("0 Runs", casinoData, true, true)}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="fancy-min-max-box">
                    <div className="fancy-min-max">
                      <span className="w-100 d-block">Min: 50.00</span>
                      <span className="w-100 d-block">Max: 25K</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="fancy-market" data-title="OPEN">
                <div className="market-row">
                  <div className="market-nation-detail">
                    <span className="market-nation-name pointer">1 Runs
                    <p className="casino-nation-book d-none d-md-block w-100">
                        {getCasinoPlExposureByRunner(casinoPlData, "1 Runs")}
                      </p>
                    </span>
                  </div>
                  <div className=" blb-box ">
                    <div className="market-odd-box back ">
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() => setBet("1 Runs", casinoData, dispatch)}
                      >
                        <span className="market-odd">
                          {getOddForEntity("1 Runs", casinoData, true)}
                        </span>
                        <span className="market-volume">
                          {getOddForEntity("1 Runs", casinoData, true, true)}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="fancy-min-max-box">
                    <div className="fancy-min-max">
                      <span className="w-100 d-block">Min: 50.00</span>
                      <span className="w-100 d-block">Max: 25K</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="fancy-market" data-title="OPEN">
                <div className="market-row">
                  <div className="market-nation-detail">
                    <span className="market-nation-name pointer">2 Runs
                    <p className="casino-nation-book d-none d-md-block w-100">
                        {getCasinoPlExposureByRunner(casinoPlData, "2 Runs")}
                      </p>
                    </span>
                  </div>
                  <div className=" blb-box ">
                    <div className="market-odd-box back ">
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() => setBet("2 Runs", casinoData, dispatch)}
                      >
                        <span className="market-odd">
                          {" "}
                          {getOddForEntity("2 Runs", casinoData, true)}
                        </span>
                        <span className="market-volume">
                          {" "}
                          {getOddForEntity("2 Runs", casinoData, true, true)}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="fancy-min-max-box">
                    <div className="fancy-min-max">
                      <span className="w-100 d-block">Min: 50.00</span>
                      <span className="w-100 d-block">Max: 25K</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="fancy-market" data-title="OPEN">
                <div className="market-row">
                  <div className="market-nation-detail">
                    <span className="market-nation-name pointer">4 Runs
                    <p className="casino-nation-book d-none d-md-block w-100">
                        {getCasinoPlExposureByRunner(casinoPlData, "4 Runs")}
                      </p>
                    </span>
                  </div>
                  <div className=" blb-box ">
                    <div className="market-odd-box back ">
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() => setBet("4 Runs", casinoData, dispatch)}
                      >
                        <span className="market-odd">
                          {" "}
                          {getOddForEntity("4 Runs", casinoData, true)}
                        </span>
                        <span className="market-volume">
                          {" "}
                          {getOddForEntity("4 Runs", casinoData, true, true)}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="fancy-min-max-box">
                    <div className="fancy-min-max">
                      <span className="w-100 d-block">Min: 50.00</span>
                      <span className="w-100 d-block">Max: 25K</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="fancy-market" data-title="OPEN">
                <div className="market-row">
                  <div className="market-nation-detail">
                    <span className="market-nation-name pointer">6 Runs
                    <p className="casino-nation-book d-none d-md-block w-100">
                        {getCasinoPlExposureByRunner(casinoPlData, "6 Runs")}
                      </p>
                    </span>
                  </div>
                  <div className=" blb-box ">
                    <div className="market-odd-box back ">
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() => setBet("6 Runs", casinoData, dispatch)}
                      >
                        <span className="market-odd">
                          {getOddForEntity("6 Runs", casinoData, true)}
                        </span>
                        <span className="market-volume">
                          {getOddForEntity("6 Runs", casinoData, true, true)}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="fancy-min-max-box">
                    <div className="fancy-min-max">
                      <span className="w-100 d-block">Min: 50.00</span>
                      <span className="w-100 d-block">Max: 25K</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="fancy-market" data-title="OPEN">
                <div className="market-row">
                  <div className="market-nation-detail">
                    <span className="market-nation-name pointer">Wicket
                    <p className="casino-nation-book d-none d-md-block w-100">
                        {getCasinoPlExposureByRunner(casinoPlData, "Wicket")}
                      </p>
                    </span>
                  </div>
                  <div className=" blb-box ">
                    <div className="market-odd-box back ">
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() => setBet("Wicket", casinoData, dispatch)}
                      >
                        <span className="market-odd">
                          {getOddForEntity("Wicket", casinoData, true)}
                        </span>
                        <span className="market-volume">
                          {getOddForEntity("Wicket", casinoData, true, true)}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="fancy-min-max-box">
                    <div className="fancy-min-max">
                      <span className="w-100 d-block">Min: 50.00</span>
                      <span className="w-100 d-block">Max: 25K</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="casino-last-result-title">
                <span>Last Result</span>
                <span>
                  <a href="/casino-results/lucky15">View All</a>
                </span>
              </div> */}
        {/* <div className="casino-last-results">
                <span className="result">2</span>
                <span className="result">W</span>
                <span className="result">1</span>
                <span className="result">6</span>
                <span className="result">0</span>
                <span className="result">2</span>
                <span className="result">0</span>
                <span className="result">0</span>
                <span className="result">2</span>
                <span className="result">4</span>
              </div> */}
      </div>
      {/* </div> */}
      {/* <div className="d-none">
            <div className="table-responsive w-100">
              <table className="table">
                <thead>
                  <tr>
                    <th>Matched Bet</th>
                    <th className="text-end">Odds</th>
                    <th className="text-end">Stake</th>
                  </tr>
                </thead>
                <tbody />
              </table>
            </div>
          </div> */}
      {/* </div> */}
      {/* </div> */}

      {/* </div> */}
    </CasinoPage>
  );
}
